// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataset-header-Ib0HdL{padding-left:0!important;padding-right:12px!important}.modal-Jk7GUh.upgrade-level-PFtmtS .semi-modal-body{height:0;padding-bottom:0}.modal-Jk7GUh.upgrade-level-PFtmtS .semi-modal-content{background-color:rgb(var(--white-1))}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataset-header": `dataset-header-Ib0HdL`,
	"datasetHeader": `dataset-header-Ib0HdL`,
	"modal": `modal-Jk7GUh`,
	"upgrade-level": `upgrade-level-PFtmtS`,
	"upgradeLevel": `upgrade-level-PFtmtS`
};
export default ___CSS_LOADER_EXPORT___;
